module.exports = __webpack_public_path__ + "favourite_white.eec1a2bc5567dcf06620.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/favourite_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/favourite_white.svg
// module chunks = styles